import React from "react";
import InfoImage from "../../assets/backgrounds/tabla-grades.svg";
import Modal from 'react-bootstrap/Modal';
import { useState } from "react";
import { useHistory } from "react-router-dom";
import "./Info.scss"
import { List, ListItem, ListItemIcon } from "@material-ui/core";
import { ListItemButton } from "@mui/material";
import { CheckCircleOutlineOutlined } from "@material-ui/icons";



export const What = () => {

    const [show, setShow] = useState(true);
    let history = useHistory();


    const handleClose = () => {
        setShow(false);
        history.push({
            pathname: `/score`,
        });
    };

    return (

        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton style={{ border: "0px" }}>
            </Modal.Header>
            <Modal.Body>
                <div className="container grade-what">
                    <p className="ps-4 pe-4 text-justify">
                        El Grade es nuestro sistema de calificación, único e el mercado,
                        y se basa en la labor de prevención, vigilancia y control de riesgos
                        desarrollada desde el país de origen de estos por nuestros más de 1.500 analistas*.
                    </p>
                    <List className="list">
                        <ListItem disablePadding>
                            <div className="row ps-2">
                                <div className="col-1">
                                    <ListItemButton>
                                        <ListItemIcon style={{color:'#f4bb64'}}>
                                            <CheckCircleOutlineOutlined />
                                        </ListItemIcon>
                                    </ListItemButton>
                                </div>
                                <div className="col-10 ps-xl-0 pt-2">
                                    <p className="ps-3 ps-xl-0"><strong>El Grade es la calificación interna</strong> del riesgo de cada cliente, que
                                        <strong> valora la probabilidad de impago</strong> de un deudor en los próximos 12 meses.</p>
                                </div>
                            </div>
                        </ListItem>
                        <ListItem disablePadding>
                            <div className="row ps-2">
                                <div className="col-1">
                                    <ListItemButton>
                                        <ListItemIcon style={{color:'#f4bb64'}}>
                                            <CheckCircleOutlineOutlined/>
                                        </ListItemIcon>
                                    </ListItemButton>
                                </div>
                                <div className="col-11 pt-2 ps-3">
                                    <p className="ps-3 ps-xl-0"><strong>Se fija por los Analista</strong> de Información de Solunion para cada empresa.</p>
                                </div>
                            </div>
                        </ListItem>
                        <ListItem disablePadding>
                            <div className="row ps-2">
                                <div className="col-1">
                                    <ListItemButton>
                                        <ListItemIcon style={{color:'#f4bb64'}}>
                                            <CheckCircleOutlineOutlined />
                                        </ListItemIcon>
                                    </ListItemButton>
                                </div>
                                <div className="col-10 ps-xl-0 pt-2">
                                    <p className="ps-3 ps-xl-0"><strong>Se compone de</strong> información referente a la propiedad, gestión y
                                        estrategia de la empresa, ingresos y rentabilidad, liquidez y apalancamiento financiero,
                                        flujo de efectivo y métricas de crédito, y datos complementarios como políticas ESG.
                                    </p>
                                </div>
                            </div>
                        </ListItem>
                        <ListItem disablePadding>
                            <div className="row ps-2">
                                <div className="col-1">
                                    <ListItemButton>
                                        <ListItemIcon style={{color:'#f4bb64'}}>
                                            <CheckCircleOutlineOutlined />
                                        </ListItemIcon>
                                    </ListItemButton>
                                </div>
                                <div className="col-10 ps-xl-0 pt-2">
                                    <p className="ps-3 ps-xl-0"><strong>Fuentes de información complementarias </strong> para robustecer
                                        las métricas anteriores como referencias bancarias y listas negras,
                                        referencias de otros clientes, agencias de información,
                                        contacto directo con los deudores de nuestros clientes.</p>
                                </div>
                            </div>
                        </ListItem>
                    </List>
                    <div className="container">
                    <div className="row">
                        <div className="grades-table-text">
                            Una herramienta clave en la gestión del riesgo de tu actividad,
                            que te permite conocer la calificación de más de 80 millones de
                            empresas de todo el mundo en función de la probabilidad de impago que presenten (Grade):
                        </div>
                        <div className="col-xl-7 col-12">
                            <img className="pdf-image-modal w-100 px-xl-5 px-3 pt-4" alt="pdf-info-modal" src={InfoImage} />
                        </div>
                    </div>
                    </div>
                </div>
               
            </Modal.Body>
            <p className="text-end pe-4 close-text" onClick={handleClose}>Cerrar</p>
        </Modal>

    )
}